import { render, staticRenderFns } from "./ServiceOrderDetail.vue?vue&type=template&id=0860cbb7&scoped=true&"
import script from "./ServiceOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderDetail.vue?vue&type=style&index=0&id=0860cbb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0860cbb7",
  null
  
)

export default component.exports